import { useEffect, useState } from "react";

const useCountAnimation = (target, duration = 1000) => {
  const [count, setCount] = useState(0);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    let start = 0;
    const end = parseInt(target);

    if (!end || end <= 0) {
      setCount(0);
      setFinished(true);
      return;
    }

    const increment = Math.max(1, end / (duration / 16));

    const timer = setInterval(() => {
      start += increment;

      if (start >= end) {
        start = end;
        clearInterval(timer);
        setFinished(true);
      }

      setCount(Math.floor(start));
    }, 16);

    return () => clearInterval(timer);
  }, [target, duration]);

  return { count, finished };
};

export default useCountAnimation;
